export default __webpack_public_path__ + "static/media/harvest-client-id.eb1348b8.png";